import saveSessionService from 'core/services/sessionManagement/save'
import storage from 'proxy-storage'

export default async function saveSession(session: Pivot.Session) {
  await saveSessionService(session)

  const hcStorage = storage.getItem('hc')
  hcStorage.session = session
  storage.setItem('hc', hcStorage)
}
